function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m399.83 54.398c-0.0625-0.27734-0.23047-0.49609-0.3125-0.75781-0.13672-0.44922-0.31641-0.88281-0.53516-1.2969-0.25-0.47656-0.55078-0.92188-0.89453-1.3359-0.27734-0.34375-0.58203-0.66406-0.91406-0.96094-0.40234-0.33984-0.84375-0.63281-1.3125-0.87891-0.39453-0.23828-0.8125-0.44141-1.2461-0.60938-0.51953-0.16406-1.0586-0.27344-1.6016-0.32812-0.33203-0.097657-0.67188-0.17578-1.0156-0.23047h-40.336c-2.0625-27.848-14.984-48-31.664-48s-29.602 20.152-31.664 48h-16.672c-2.0625-27.848-14.984-48-31.664-48s-29.602 20.152-31.664 48h-16.672c-2.0625-27.848-14.984-48-31.664-48s-29.602 20.152-31.664 48h-16.672c-2.0625-27.848-14.984-48-31.664-48s-29.602 20.152-31.664 48h-40.336c-4.418 0-8 3.582-8 8v416c0 4.418 3.582 8 8 8h384c4.418 0 8-3.582 8-8v-24h72c2.4023 0 4.6758-1.082 6.1914-2.9414 1.5195-1.8633 2.1211-4.3047 1.6406-6.6602zm-79.832-38.398c5.7773 0 13.84 12.258 15.617 32h-31.203c1.7461-19.742 9.8086-32 15.586-32zm-80 0c5.7773 0 13.84 12.258 15.617 32h-31.203c1.7461-19.742 9.8086-32 15.586-32zm-80 0c5.7773 0 13.84 12.258 15.617 32h-31.203c1.7461-19.742 9.8086-32 15.586-32zm-80 0c5.7773 0 13.84 12.258 15.617 32h-31.203c1.7461-19.742 9.8086-32 15.586-32zm-64 48h32.336c2.0625 27.848 14.984 48 31.664 48 4.418 0 8-3.582 8-8s-3.582-8-8-8c-5.7773 0-13.84-12.258-15.617-32h63.953c2.0898 27.848 14.984 48 31.664 48 4.418 0 8-3.582 8-8s-3.582-8-8-8c-5.7773 0-13.84-12.258-15.617-32h63.953c2.0898 27.848 14.984 48 31.664 48 4.418 0 8-3.582 8-8s-3.582-8-8-8c-5.7773 0-13.84-12.258-15.617-32h63.953c2.0898 27.848 14.984 48 31.664 48 4.418 0 8-3.582 8-8s-3.582-8-8-8c-5.7773 0-13.84-12.258-15.617-32h79.617v80h-368zm368 400h-368v-304h368zm16-32v-298.4l62.168 298.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m176 288h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m256 288h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m96 288h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m176 368h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m256 368h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m96 368h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m176 208h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m256 208h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m336 288h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m336 368h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m336 208h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m96 208h-32c-4.418 0-8 3.582-8 8v32c0 4.418 3.582 8 8 8h32c4.418 0 8-3.582 8-8v-32c0-4.418-3.582-8-8-8zm-8 32h-16v-16h16z"
});

var SvgAppointment = function SvgAppointment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "480pt",
    height: "480pt",
    viewBox: "0 0 480 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppointment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appointment.c04769f8.svg";
export { ForwardRef as ReactComponent };